import { SyncRouteService } from 'common/data';
import { BaseService } from 'core/services';
import _ from 'lodash';

class SyncService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new SyncRouteService());
	}

	syncAsync(sourceOfChange) {
		var url = this.routeService.syncAsync(sourceOfChange);
		return this.apiClient.get(url);
	}

	syncByChannelAsync(id, sourceOfChange) {
		var url = this.routeService.syncByChannelAsync(id, sourceOfChange);
		return this.apiClient.get(url);
	}
}

export default SyncService;



// WEBPACK FOOTER //
// ./src/common/data/services/SyncService.js